import { Collection } from '../types'
import { Breakpoint } from '../../../types'
import { buildClass } from './buildClass'

export const buildClasses =
  <TSingle extends string | number>(
    prefix:
      | ((value: TSingle | undefined, breakpoint?: Breakpoint) => string)
      | string,
  ) =>
  (items: TSingle | Collection<TSingle> | undefined) => {
    const parser =
      typeof prefix === 'string' ? buildClass<TSingle>(prefix) : prefix

    if (typeof items === 'object') {
      return Object.keys(items as Collection<TSingle>).map((breakpoint) => {
        const value = (items as Collection<TSingle>)[
          breakpoint as Breakpoint
        ] as TSingle
        return parser(value, breakpoint as Breakpoint)
      })
    }

    return [parser(items)]
  }
